import { render, staticRenderFns } from "./PopupStaffServiceDetail.vue?vue&type=template&id=c31ddae0"
import script from "./PopupStaffServiceDetail.vue?vue&type=script&lang=js"
export * from "./PopupStaffServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./PopupStaffServiceDetail.vue?vue&type=style&index=0&id=c31ddae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports